import { MediaPlayer, MediaPlayerProvider } from '@aicon-dev/caas-media-player';

function App() {
  const token = location.pathname.replace('/', '');
  const searchParams = new URLSearchParams(location.pathname);

  const position = searchParams.get('position');

  return (
    <MediaPlayerProvider>
      <MediaPlayer
        token={token}
        aspectRatio="full"
        position={position ? Number(position) : undefined}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      />
    </MediaPlayerProvider>
  );
}

export default App;
